"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PackageDetailsPage = void 0;
var react_1 = __importStar(require("react"));
var react_redux_1 = require("react-redux");
require("./PackageDetailsPage.scss");
var PackageDetails_1 = __importDefault(require("../components/PackageDetails"));
var Page_1 = require("@app/components/layout/Page");
var selectors_1 = require("@app/features/transfers/state/selectors");
var config_1 = require("@app/shared/config");
var PackageDetailsPage = /** @class */ (function (_super) {
    __extends(PackageDetailsPage, _super);
    function PackageDetailsPage() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PackageDetailsPage.prototype.render = function () {
        var packageId = this.props.match.params.packageId;
        return (react_1.default.createElement(Page_1.Page, { title: "Package Details", className: "package-details-page", isAsperaInitializing: this.props.asperaInitializing, isLoading: !this.props.asperaLoaded || this.props.isLoading },
            react_1.default.createElement(PackageDetails_1.default, { packageId: packageId, downloadSizeLimitInMB: config_1.Config.HTTP_TRANSFER_MAX_PACKAGE_SIZE })));
    };
    return PackageDetailsPage;
}(react_1.Component));
exports.PackageDetailsPage = PackageDetailsPage;
var mapStateToProps = function (store) {
    return {
        asperaInitializing: selectors_1.isAsperaInitializing(store),
        asperaLoaded: selectors_1.isAsperaLoaded(store),
        isLoading: store.packageDetails.isLoading
    };
};
exports.default = react_redux_1.connect(mapStateToProps)(PackageDetailsPage);
